/**
 * Created by amir on 4/24/17.
 */

import usa from './../../images/usa.png';
import israel from './../../images/israel.png';
import italy from './../../images/italy.png';
import spain from './../../images/spain.png';
import greece from './../../images/greece.png';
import france from './../../images/france.png';
import turkey from './../../images/turkey.png';
import denmark from './../../images/denmark.png';
import germany from './../../images/germany.png';
import hungary from './../../images/hungary.png';
import czech from './../../images/czech.png';
import slovakia from './../../images/slovakia.png';
import romania from './../../images/romania.png';
import bulgaria from './../../images/bulgaria.png';
import norway from './../../images/norway.png';
import swedish from '../../images/sweden.png';
import Indonesia from "./../../images/Indonesia.png";
import Turkey from "./../../images/turkey.png";

export default class LanguageService {
    static get $inject() {
        return ['gettextCatalog', '$localStorage', '$http', '$rootScope'];
    }

    constructor(gettextCatalog, $localStorage, $http, $rootScope) {
        this.gettextCatalog = gettextCatalog;
        this.$localStorage = $localStorage;
        this.$http = $http;
        this.$rootScope = $rootScope;

        this.LANGUAGES = [{name: 'English(US)', shortcut: 'en', img: usa},
                          {name: 'עברית', shortcut: 'he' , img: israel},
                          {name: 'Italiano', shortcut: 'it' , img: italy},
                          {name: 'Español', shortcut: 'es' , img: spain},
                          {name: 'Ελληνικά', shortcut: 'el' , img: greece},
                          {name: 'Français', shortcut: 'fr' , img: france},
                          {name: 'Türkçe', shortcut: 'tr' , img: turkey},
                          {name: 'Dansk', shortcut: 'da' , img: denmark},
                          {name: 'Deutsch', shortcut: 'de' , img: germany},
                          {name: 'Magyar', shortcut: 'hu' , img: hungary},
                          {name: 'Čeština', shortcut: 'cs' , img: czech},
                          {name: 'Slovenčina', shortcut: 'sk' , img: slovakia},
                          {name: 'Română', shortcut: 'ro' , img: romania},
                          {name: 'български', shortcut: 'bg' , img: bulgaria},
                          {name: 'Norsk', shortcut: 'nn' , img: norway},
                          {name: 'Svenska', shortcut: 'sv' , img: swedish},
                          {name: 'Indonesian', shortcut: 'id' , img: Indonesia},
                          {name: 'Turkish', shortcut: 'id' , img: Turkey},
        ];
    }

    static get LANGUAGES() {

        return this.LANGUAGES;
    }

    setLanguageByShortcut(languageShortcut) {

        let lang = null;

        for (let Languages of this.LANGUAGES) {

            if (Languages.shortcut == languageShortcut) {

                lang = Languages;
                break;
            }
        }

        if(lang) {
            this.setLanguage(lang);
        }
        else {
            this.setLanguage(this.LANGUAGES[0]);
        }
    }

    setLanguage(lang) {

        this.currentLanguageImage = lang.img;
        this.gettextCatalog.setCurrentLanguage(lang.shortcut);
        this.$http.defaults.headers.common['X-Crow-Language'] = this.$localStorage.language = lang.shortcut;
        this.$rootScope.$broadcast('languageChanged');
    }

    getLanguage() {

        for (let Languages of this.LANGUAGES) {

            if (Languages.shortcut == this.gettextCatalog.getCurrentLanguage()) {

                return Languages;
            }
        }
    }
    
    getTranslatableText(text) {
        if(text) {
            return this.gettextCatalog.getString(text).split('_').join(' ');
        }
    }

}


/** WEBPACK FOOTER **
 ** ./src/services/app/language.service.js
 **/